module.exports = __webpack_public_path__ + "img/SL-M-200-240.0da28d97.svg";